import React, { useRef, useState, useEffect } from 'react';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import NextArrow from '../../../assets/images/next-arrow.png';
import PrevArrow from '../../../assets/images/prev-arrow.png';
import { Link } from 'react-router-dom';
import MarketPriceItem from './marketPriceItem';

const SlideMarketPrices = ({ marketPrices = [], catalogue, tab }) => {
  const sliderRef = useRef(null);

  const [currentIndex, setCurrentIndex] = useState(0);
  const [slidesToShow, setSlidesToShow] = useState(marketPrices.length < 2 ? 1 : 2);
  useEffect(() => {
    const updateSlidesToShow = () => {
      setSlidesToShow(marketPrices.length < 2 ? 1 : 2);
    };
    updateSlidesToShow();
    window.addEventListener('resize', updateSlidesToShow);
    return () => window.removeEventListener('resize', updateSlidesToShow);
  }, [marketPrices.length]);

  const isFirst = currentIndex === 0;
  const isLast = currentIndex >= marketPrices.length - slidesToShow + 1;

  function NextSlide({ onClick, isVisible }) {
    if (!isVisible) return null;
    return (
      <div className="position-absolute z-1 pointer slider-next-right" onClick={onClick}>
        <div className="arrow-wrapper">
          <img src={NextArrow} alt="Next" />
        </div>
      </div>
    );
  }

  function PrevSlide({ onClick, isVisible }) {
    if (!isVisible) return null;
    return (
      <div className="position-absolute z-1 pointer slider-prev-left" onClick={onClick}>
        <div className="arrow-wrapper">
          <img src={PrevArrow} alt="Previous" />
        </div>
      </div>
    );
  }

  const slickNext = () => {
    sliderRef.current?.slickNext();
  };

  const slickPrev = () => {
    sliderRef.current?.slickPrev();
  };

  const settings = {
    className: 'center',
    centerMode: false,
    infinite: false,
    centerPadding: '60px',
    slidesToShow,
    speed: 500,
    nextArrow: <NextSlide onClick={slickNext} isVisible={!isLast} />,
    prevArrow: <PrevSlide onClick={slickPrev} isVisible={!isFirst} />,
    afterChange: index => setCurrentIndex(index),
  };

  return (
    <>
      {marketPrices.length > 1 ? (
        <Slider {...settings} ref={sliderRef}>
          {marketPrices.map(market => {
            const priceDifference = market.get_market_price_last?.price_difference || 0;
            return (
              <div key={market.id} className="col d-flex align-items-stretch">
                <MarketPriceItem market={market} priceDifference={priceDifference} tab={tab} />
              </div>
            );
          })}

          {marketPrices.length >= slidesToShow && (
            <div className="col d-flex justify-content-center align-items-center text-center box-show-all">
              <Link
                to="/chuyen-muc/mat-hang-gia-ca-thi-truong"
                state={{ catalogueId: catalogue?.id, catalogueName: catalogue?.name }}
                className="d-flex flex-column align-items-center gap-2 link-show-all"
              >
                <img src={NextArrow} alt="Show all" />
                <span>Xem tất cả</span>
              </Link>
            </div>
          )}
        </Slider>
      ) : marketPrices.length > 0 ? (
        marketPrices.map(market => {
          const priceDifference = market.get_market_price_last?.price_difference || 0;
          return (
            <div key={market.id} className="col col-6">
              <MarketPriceItem market={market} priceDifference={priceDifference} tab={tab} />
            </div>
          );
        })
      ) : (
        <div className="text-center py-4">Không có dữ liệu thị trường liên quan.</div>
      )}
    </>
  );
};

export default SlideMarketPrices;
